import { connect } from "react-redux";

const mapStateToProps = (state) => ({
  isProfileNavEnabled: !!(
    state.onboarding.isOnboardingCompleted ||
    state.jarvisRMS.rmsOnboarding.isOnboardingCompleted ||
    state.jarvisOnestock.onestockOnboarding.isOnboardingCompleted ||
    state.jarvisPrime.primeOnboarding.isPrimeOnboardingCompleted ||
    state.sentimentTracker.sentimentTrackerOnboarding.isOnboardingCompleted ||
    state.PHC.PHCOnboarding.isOnboardingCompleted
  ),
});

const HubPlaceholderStore = (Container) => connect(mapStateToProps)(Container);

export default HubPlaceholderStore;
